// landhep.id carries the public pages (landing, /privasi, /flei); the app itself
// lives on platform.landhep.id. Links that cross between the two have to become
// absolute on those hosts — anywhere else (localhost, a tunnel) they stay relative,
// so local development keeps working on one origin.

export const LANDING_ORIGIN = "https://landhep.id";
export const PLATFORM_ORIGIN = "https://platform.landhep.id";

const LANDING_HOSTS = new Set(["landhep.id", "www.landhep.id"]);
const host = () => (typeof window === "undefined" ? "" : window.location.hostname);

export const onPlatformHost = () => host() === "platform.landhep.id";

// A path inside the app, from wherever the visitor is now.
export const appHref = (path) => (LANDING_HOSTS.has(host()) ? PLATFORM_ORIGIN + path : path);

// A public page, from wherever the visitor is now.
export const landingHref = (path) => (onPlatformHost() ? LANDING_ORIGIN + path : path);

// Go to `href`: a full page load when it points at another origin, the router
// otherwise (so the SPA does not reload on the same host).
export function go(navigate, href) {
  if (/^https?:\/\//.test(href)) window.location.assign(href);
  else navigate(href);
}
